var map = {
	"./en": [
		"3fab"
	],
	"./en.js": [
		"3fab"
	],
	"./messages": [
		"3b9f"
	],
	"./messages.js": [
		"3b9f"
	],
	"./ms": [
		"c18c",
		"lang-ms"
	],
	"./ms.js": [
		"c18c",
		"lang-ms"
	],
	"./sm": [
		"fd99",
		"lang-sm"
	],
	"./sm.js": [
		"fd99",
		"lang-sm"
	],
	"./to": [
		"a61f",
		"lang-to"
	],
	"./to.js": [
		"a61f",
		"lang-to"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5892";
module.exports = webpackAsyncContext;